import { httpClient } from '@bcba/client-auth';
import { ExplorerUpdateSignUpDto } from '../dtos/getExplorerUpdateSignupDto';

const basePath = '/sign-up-requests';

export const updateSignUpRequest = (
  signupRequestUuid: string,
  body: ExplorerUpdateSignUpDto,
): Promise<ExplorerUpdateSignUpDto> => {
  return httpClient.patch(`${basePath}/${signupRequestUuid}`, body);
};
